const PATIENT_STATE = {
  NoEnrollments: { value: 0, text: 'No Enrollments' },
  AnyEnrollmentsRegistering: { value: 1, text: 'Registering' },
  AnyEnrollmentsActive: { value: 2, text: 'Active' }
};

type PATIENT_STATE = typeof PATIENT_STATE;

export default PATIENT_STATE;
